import * as types from '../../mutationTypes';

export default {
  [types.SET_EXCURSION_TYPES](state, types) {
    state.types = types;
  },
  [types.SET_AXIOS](state, axios) {
    state.axios = axios;
  },
  [types.SET_RISK_CATEGORIES](state, riskCategories) {
    if (riskCategories.transports) {
      state.riskCategories.transports = [];
      riskCategories.transports.forEach((transport) => {
        state.riskCategories.transports.push(...transport.options);
      });
    }
    if (riskCategories.venues) {
      state.riskCategories.venues = [];
      riskCategories.venues.forEach((venue) => {
        state.riskCategories.venues.push(...venue.options);
      });
    }
    if (riskCategories.foods) {
      state.riskCategories.foods = [];
      riskCategories.foods.forEach((food) => {
        state.riskCategories.foods.push(...food.options);
      });
    }
    if (riskCategories.accommodations) {
      state.riskCategories.accommodations = [];
      riskCategories.accommodations.forEach((accommodation) => {
        state.riskCategories.accommodations.push(...accommodation.options);
      });
    }
    if (riskCategories.activities) {
      state.riskCategories.activities = [];
      riskCategories.activities.forEach((activity) => {
        activity.subCategories.forEach((subCategory) => {
          state.riskCategories.activities.push(...subCategory.options);
        });
      });
    }
  },
  [types.SET_EXCURSION_ID](state, id) {
    state.id = id;
  },
  [types.RESET_EXCURSION](state) {
    state.id = '0';
    state.types = [];
    state.riskCategories = {
      transports: [],
      venues: [],
      accommodations: [],
      foods: [],
      activities: []
    };
  }
};
